import { Salutation } from './user'
import { IntegrationType } from './config'
import { PlacementType } from './placementType'
import { SolarIntent } from './solarIntent'

export enum ReceiveLeadRequestRealEstateType {
  APARTMENT = 'APARTMENT_BUY',
  HOUSE = 'HOUSE_BUY',
  LAND = 'PROPERTY_BUY',
  COMMERCIAL = 'COMMERCIAL_BUY',
  DEFAULT = 'DEFAULT',
}

export enum BusinessArea {
  SALE = 'SALE',
  FINANCING = 'FINANCING',
  DECLUTTERING = 'DECLUTTERING',
  ANNUITY = 'ANNUITY',
  PROJECT_SALES = 'PROJECT_SALES',
  CAPITAL_INVESTMENT = 'CAPITAL_INVESTMENT',
}

export enum Iv24Intention {
  SELL = 'SELL',
  RENT_OUT = 'RENT_OUT',
  VALUATION = 'VALUATION',
  MODERNIZATION = 'MODERNIZATION',
  PROPERTY_BUY = 'PROPERTY_BUY',
  DEBT_RESTRUCTURING = 'DEBT_RESTRUCTURING',
  FOLLOW_UP_FINANCING = 'FOLLOW_UP_FINANCING',
  CONSTRUCTION_PROJECT = 'CONSTRUCTION_PROJECT',
  RECONSTRUCTION = 'RECONSTRUCTION',
  OTHER = 'OTHER',
  UNKNOWN_SALE = 'UNKNOWN_SALE',
  UNKNOWN_BAUFI = 'UNKNOWN_BAUFI',
  ANNUITY = 'ANNUITY',
  INVESTMENT_BUY = 'INVESTMENT_BUY',
  OWN_USE_BUY = 'OWN_USE_BUY',
  RETIREMENT = 'RETIREMENT',
  GENERAL_INFORMATION = 'GENERAL_INFORMATION',
  OFFERS_MARKET_INFORMATION = 'OFFERS_MARKET_INFORMATION',
  CAPITAL_INVESTMENT_OR_PROPERTY_ONLY = 'CAPITAL_INVESTMENT_OR_PROPERTY_ONLY',
  SAVE_TAXES = 'SAVE_TAXES',
  RENT = 'RENT',
}

export interface OwnerBackendReceiveLeadRequest {
  salutation: Salutation
  acceptance: boolean
  firstname: string
  cellphonenumber: string
  email: string
  lastname: string
  postcode: string
  gacId: string | null
  address?: string | null
  leadSource: string
  numberofrooms?: number
  livingspace?: string | number
  specialization: ReceiveLeadRequestRealEstateType
  geotype: string
  city: string
  userIntent?: string
  saletimehorizon?: string
  ownership?: string
  propertysize?: string | number | null
  duplicateUser?: boolean
  valuation: string | null
  propertydevelopment?: string
  propertydeveloped?: string
  propertycut?: string
  commercialPropertyType?: string
  landSizeEnabled?: boolean
  propertyOfferOptIn?: boolean
  cooperationId?: string
  integrationType?: IntegrationType
  locationRange?: number
  street?: string
  houseNumber?: string

  // IV24 specific
  businessArea?: BusinessArea | null
  iv24Intention?: Iv24Intention | null
  adGroup?: string | null
  adKeyword?: string | null
  adPlacement?: string | null
  adCampaign?: string | null
  adChannel?: string | null
  adDevice?: string | null
  formUrl?: string | null
  formPage?: string | null
  formType?: string | null
  qcTransactionId?: string | null
  kwMatchType?: string | null
  clickId?: string | null

  // Extended buyer leads
  affordability?: number
  extendedBuyerLead?: boolean
  equity?: number
  income?: number
  employment?: string
  furtherRealEstateInformation?: string

  isConsultationAccepted?: boolean
}

export interface BackendReceiveSolarLeadRequest {
  acceptance: boolean
  placementType?: PlacementType
  intent?: SolarIntent
  saleTimeHorizon?: string
  postcode: string
  phoneNumber: string
  salutation?: Salutation
  firstName?: string
  lastName?: string
  email: string
  cooperationId?: string
}
